import { colors } from 'kaizen-ui-colors/lib';
import * as React from 'react';
import styled from 'styled-components';
import Coin2 from './base/Icon/Kaizen/Coin2';
import Project from '../../domain/entity/Project';

const Wrapper = styled.span`
  display: inline-flex;
  align-items: center;
  font-size: 11px;
`;

const QuotaCount = styled.span`
  font-family: Verdana, sans-serif;
  margin-left: 4px;
`;

const VariationPeriod = styled.span`
  margin-left: 4px;
`;

const Warning = styled.span`
  color: ${colors.lava__fe7877};
  font-weight: bold;
`;

const VariationQuota = (props: { project: Project }) => {
  const { project } = props;

  if (project.a11yType() === 'private' || project.a11yType() === 'growth') {
    return null;
  }

  return (
    <Wrapper>
      <Coin2 size={20} />
      {project.quotaCount === '0.0' ? (
        <QuotaCount>{project.quotaCount}</QuotaCount>
      ) : (
        <span>
          <QuotaCount>{project.quotaCount}</QuotaCount>
          <VariationPeriod>
            {project.quotaPeriod === 0 ? (
              <Warning>期限切れ</Warning>
            ) : project.quotaPeriod <= 7 ? (
              <Warning>あと{project.quotaPeriod}日</Warning>
            ) : (
              <span>あと{project.quotaPeriod}日</span>
            )}
          </VariationPeriod>
        </span>
      )}
    </Wrapper>
  );
};

export default VariationQuota;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/presentation/component/VariationQuota.tsx